// const BASE_URL = "http://localhost:4500";

const BASE_URL = "https://admin-backend-kd9a.onrender.com";

export default BASE_URL;
